import React from 'react'
import IconCloseNormal from 'components/partials/IconCloseNormal'

function MessageError({ message, onDismiss, closeLabel }) {
  return (
    <div className="message">
      {onDismiss && (
        <button
          className="message-close"
          onClick={onDismiss}
        >
          <IconCloseNormal />
          {closeLabel}
        </button>
      )}
      <div className="site-message">{message}</div>
    </div>
  )
}

export default MessageError
